import { useAccount } from '@/api/useAccount';
import { Letterhead } from './Letterhead';

/**
 * The signed-in account's letterhead, for the office's own documents. Renders
 * nothing until the account has loaded — the document below does not wait on
 * it, and a placeholder would only shift the page when it arrived.
 */
export function AccountLetterhead() {
  const account = useAccount();
  if (!account.data) return null;
  const a = account.data;
  return (
    <Letterhead
      company={{
        name: a.name,
        address: a.address,
        phone: a.phone,
        licenseNumber: a.licenseNumber,
        logoPath: a.logoPath,
      }}
    />
  );
}
